import { Divider, Grid2, Stack, Typography } from "@mui/material";

import { parseStringToDate } from "~/modules/app/util/dateHelpers";
import { formatDate } from "~/modules/app/util/formatters";
import { GaiaMiniMap } from "~/modules/map/components/GaiaMiniMap";

import ShiftItemPaymentBadge from "../ShiftItemPaymentBadge";
import ShiftTimeAndTravel from "../ShiftItemTimeAndTravel";
import ShiftItemTravelBadges from "../ShiftItemTravelBadges";
import ShiftVisits from "../ShiftVisits";
import { ShiftDetailsFragment } from "./fragments.generated";

type Props = {
    shift: ShiftDetailsFragment;
};

export default function ShiftDetails({ shift }: Props) {
    const summary = shift.summary;
    const mapGeometry = summary.mapPreviewGeometry;

    return (
        <Grid2 container direction={{ xs: "column", md: "row" }} justifyContent="space-between">
            <Grid2 size={{ xs: 12, md: 6 }} p={2} component={Stack} divider={<Divider />} gap={1}>
                <Stack>
                    <Typography variant="subtitle2" fontWeight="bold">
                        {formatDate(parseStringToDate(shift.startTime))}
                    </Typography>

                    <Stack mb={2} gap={0.5}>
                        <Typography variant="h6" color="primary">
                            {summary.plannerAreaHeading}
                        </Typography>
                        <Typography variant="body2">{summary.plannerAreaAddress}</Typography>
                    </Stack>
                    <Stack gap={2}>
                        <ShiftVisits shift={shift} />
                        <ShiftTimeAndTravel shift={shift} />
                    </Stack>
                </Stack>

                <Stack gap={1}>
                    <ShiftItemTravelBadges shift={shift} />
                    <ShiftItemPaymentBadge shift={shift} />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
                {mapGeometry && <GaiaMiniMap geometry={mapGeometry} sx={{ height: { xs: "25vh", md: "100%" }, width: "100%" }} />}
            </Grid2>
        </Grid2>
    );
}
